import Titles from '../components/Titles/Titles';
import PrivacyTermsComponent from '../components/PrivacyTerms/PrivacyTermsComponent';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const Terms = () => {
    const seo = usePageSEO('terms');

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <Titles pageType="terms" additionalElementClassName="terms__date"/>
            <PrivacyTermsComponent type="terms"/>
        </>
    );
};

export default Terms;